export default __webpack_public_path__ + "static/media/verdansk84.3b6783f2.jpg";